export function useMapAddressAndContacts(data, modelValue, addressType) {

    modelValue[addressType].id = data.id;
    modelValue[addressType].name = data.name;
    modelValue[addressType].addressLine1 = data.addressLine1;
    modelValue[addressType].addressLine2 = data.addressLine2;
    modelValue[addressType].addressLine3 = data.addressLine3;
    modelValue[addressType].city = data.city;

    if (data.country) {
        modelValue[addressType].country = modelValue.metaData.countries.find(c => c.id === data.country).value;
    }

    modelValue[addressType].county = data.county;
    modelValue[addressType].postCode = data.postCode;

    modelValue.isUpdate[addressType] = true;

    if(data.contacts) {

        data.contacts.forEach(contact => {
            modelValue[addressType].contacts.push(contact)
        })
    }

}
